export const COMMON_CONSTANTS = {
  PHONE: "phone",
  EMAIL: "email",
  ACCOUNT_SUSPENDED: "accountSuspended",
  CUSTOMER_PORTAL: "customerPortal",
};

export const SEAMLESS_ACCESS_CONSTANTS = {
  SELECT_CONTRACT: "selectContract",
  SUSPENDED_CA_TEXT: "suspendedCAText",
  CHOOSE_CA_TEXT: "chooseCAText",
  CA_DROPDOWN_HELPERTEXT_LINK: "CADropdownHelperTextLink",
  SUSPENDED_TEXT: "suspendedText",
  OR_EMAIL: "orEmail",
  SELECT_CA_BUTTON: "selectCAButton",
  CA_DROPDOWN_PLACEHOLDER: "CADropdownPlaceholder",
  CA_DROPDOWN_HELPERTEXT: "CADropdownHelperText",
  CA_DROPDOWN_LABEL: "CADropdownLabel",
};

export const BILLINGPAYMENTS_REDBANNER_CONSTANTS = {
  OUTSTANDING_CHARGES: "outstandingCharges",
  PAY_FULL_AMOUNT: "payFullAmount",
  CONTACT_US: "contactUs",
  OR_AT: "orAt",
  ACCOUNT_HOLDER: "accountHolder",
  ACCOUNT_NUMBER: "accountNumber",
  IBAN: "IBAN",
  SWIFTBIC: "SWIFTBIC",
  MAKE_A_PAYMENT: "makeAPayment",
  ACCOUNT_RESTORED: "accountRestored",
  PROOF_OF_PAYMENT: "proofOfPayment",
  RESTORING_CONDITION: "restoringCondition",
  PAYMENT_CLEAR_TEXT: "paymentClearText",
  ACCOUNT_RESTORED_TEXT: "accountRestoredText",
  SORT_CODE: "sortCode",
};

export const AUTOPAY_CONSTANTS = {
  ACCOUNT_PAYMENTS_IN_ORDER: "accountPaymentsInOrder",
  ACCOUNT_PAYMENTS_IN_ORDER_WITH_AUTOPAY: "accountPaymentsInOrderWithAutopay",
  MANAGE_PAYMENT_METHODS: "managePaymentMethods",
};

export const REDBALL_INACTIVE_ACCOUNT_CONSTANTS = {
  ACCOUNT_TERMINATED: "accountTerminated",
  SUSPENDED_MSG_ONE: "suspendedMsgOne",
  SUSPENDED_MSG_TWO: "suspendedMsgTwo",
  NA_ADMIN_CONTACT_TEXT: "naAdminContactText",
  EMEA_ADMIN_CONTACT_TEXT: "emeaAdminContactText",
  PHONE_ADMIN_CONTACT: "phoneAdminContactText",
  NA_ADMIN_CONTACT_TEXT_WITH_PHONE: "naAdminContactTextWithPhone",
  ON: "on",
  LOGIN_BUTTON_TEXT: "loginButtonText",
  REDBALL_CONTACT_US: "redballContactUs",
  ADMIN_CONTACT_PHONE_EMAIL: "adminContactPhoneEmail",
  CONTACT_PHONE_EMAIL: "contactPhoneEmail",
  CONTACT_PHONE: "contactPhone",
  CONTACT_PHONE_EMAIL_COLLECTION: "contactPhoneEmailCollection",
  CONTACT_NUMBER_UK: "contactNumberUK",
  CONTACT_NUMBER_FRANCE: "contactNumberFrance",
  CONTACT_NUMBER_GERMANY: "contactNumberGermany",
  CONTACT_NUMBER_NETHERLANDS: "contactNumberNetherlands",
  CONTACT_NUMBER_IRELAND: "contactNumberIreland",
  BACK_TO_LOGIN: "backToLogin",
  INACTIVE_ACCOUNT_TITLE: "inactiveAccountTitle",
  SELECT_CONTRACT_TITLE: "selectContractTitle",
};

export const COUNTRY_CODE_CONSTANTS = {
  COUNTRY_CODE_FETCH_ERROR: "Failed to fetch country code list. Please try again later.",
};

export const INVOICE_HISTORY_CONSTANTS = {
  AVAILABLE_ON: "Available on",
}
